/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Add_ResourceInputs */

const en_admin_resources_add_resource = /** @type {(inputs: Admin_Resources_Add_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Resource`)
};

const de_admin_resources_add_resource = /** @type {(inputs: Admin_Resources_Add_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressource hinzufügen`)
};

const es_admin_resources_add_resource = /** @type {(inputs: Admin_Resources_Add_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir recurso`)
};

const fr_admin_resources_add_resource = /** @type {(inputs: Admin_Resources_Add_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter la ressource`)
};

const nl_admin_resources_add_resource = /** @type {(inputs: Admin_Resources_Add_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorziening toevoegen`)
};

/** @type {(inputs: Admin_Resources_Add_ResourceInputs) => LocalizedString} */
const it_admin_resources_add_resource = en_admin_resources_add_resource;

/** @type {(inputs: Admin_Resources_Add_ResourceInputs) => LocalizedString} */
const pt_br2_admin_resources_add_resource = en_admin_resources_add_resource;

/** @type {(inputs: Admin_Resources_Add_ResourceInputs) => LocalizedString} */
const pl_admin_resources_add_resource = en_admin_resources_add_resource;

/** @type {(inputs: Admin_Resources_Add_ResourceInputs) => LocalizedString} */
const hu_admin_resources_add_resource = en_admin_resources_add_resource;

/** @type {(inputs: Admin_Resources_Add_ResourceInputs) => LocalizedString} */
const ro_admin_resources_add_resource = en_admin_resources_add_resource;

/**
* | output |
* | --- |
* | "Add Resource" |
*
* @param {Admin_Resources_Add_ResourceInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_add_resource = /** @type {((inputs?: Admin_Resources_Add_ResourceInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Add_ResourceInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_add_resource(inputs)
	if (locale === "de") return de_admin_resources_add_resource(inputs)
	if (locale === "es") return es_admin_resources_add_resource(inputs)
	if (locale === "fr") return fr_admin_resources_add_resource(inputs)
	if (locale === "nl") return nl_admin_resources_add_resource(inputs)
	if (locale === "it") return it_admin_resources_add_resource(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_add_resource(inputs)
	if (locale === "pl") return pl_admin_resources_add_resource(inputs)
	if (locale === "hu") return hu_admin_resources_add_resource(inputs)
	return ro_admin_resources_add_resource(inputs)
});
export { admin_resources_add_resource as "admin.resources.add_resource" }